import React, { useMemo, useState } from "react";
import "./ReferralProgram.css";
import InnerHeader from "../../components/InnerHeader";
import BottomNav from "../../components/BottomNav/BottomNav";
import UserBalanceHero from "../../components/UserBalanceHero/UserBalanceHero";

const refpefMoney = (value, digits = 2) => {
  const num = Number(value || 0);
  return num.toFixed(digits);
};

export default function ReferralProgram({

  referralLink = "",
  totalBonus = 0,
  referralRows = [],
  onBack,
  onSubmitAll,
}) {
  const [refpefActiveTab, setRefpefActiveTab] = useState("link");

  const refpefTitle = useMemo(() => {
    return refpefActiveTab === "link" ? "Update Bonus" : "Referral List";
  }, [refpefActiveTab]);

  const refpefRows = Array.isArray(referralRows) ? referralRows : [];

  return (
    <div className="refpef-page">
      <div className="refpef-shell">
       <InnerHeader title={refpefTitle} />

          <UserBalanceHero />

        <div className="refpef-tab-row">
          <button
            type="button"
            className={`refpef-tab-btn ${
              refpefActiveTab === "link" ? "refpef-tab-btn--active" : ""
            }`}
            onClick={() => setRefpefActiveTab("link")}
          >
            Earning Link
          </button>

          <button
            type="button"
            className={`refpef-tab-btn ${
              refpefActiveTab === "list" ? "refpef-tab-btn--active" : ""
            }`}
            onClick={() => setRefpefActiveTab("list")}
          >
            Referral List
          </button>
        </div>

        {refpefActiveTab === "link" ? (
          <div className="refpef-content">
            <div className="refpef-link-box" title={referralLink}>
              {referralLink}
            </div>

            <div className="refpef-report-title">Income Report</div>

            <div className="refpef-report-row">
              <span>Total Bonus:</span>
              <strong>{refpefMoney(totalBonus, 3)}</strong>
            </div>

            <button
              type="button"
              className="refpef-submit-btn"
              onClick={() => onSubmitAll && onSubmitAll()}
            >
              Submit All
            </button>
          </div>
        ) : (
          <div className="refpef-content refpef-content--list">
            <div className="refpef-table-wrap">
              <table className="refpef-table">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>User Name</th>
                    <th>Bonus</th>
                    <th>Turnover</th>
                  </tr>
                </thead>

                <tbody>
                  {refpefRows.length === 0 ? (
                    <tr>
                      <td className="refpef-empty-row" colSpan="4">
                        No record found!
                      </td>
                    </tr>
                  ) : (
                    refpefRows.map((row, index) => (
                      <tr key={row.id || index}>
                        <td>{index + 1}</td>
                        <td>{row.username || row.userName || "-"}</td>
                        <td>{row.bonus ?? "-"}</td>
                        <td>{row.turnover ?? "-"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      <BottomNav />
    </div>
  );
}